import { Theme, Components } from '@mui/material/styles';

/* eslint-disable import/prefer-default-export */
export const feedbackCustomizations: Components<Theme> = {
  MuiAlert: {
    styleOverrides: {
      root: ({ theme }) => {
        const severityMap: Record<string, { bg: string; border: string; color: string; icon: string }> = {
          warning: { bg: 'var(--warning-bg)', border: 'var(--warning)', color: 'var(--warning)', icon: 'var(--warning)' },
          error:   { bg: 'var(--danger-bg)',  border: 'var(--danger)',  color: 'var(--danger)',  icon: 'var(--danger)' },
          success: { bg: 'var(--success-bg)', border: 'var(--success)', color: 'var(--success)', icon: 'var(--success)' },
          info:    { bg: 'var(--info-bg)',    border: 'var(--info)',    color: 'var(--info)',    icon: 'var(--info)' },
        };
        return {
          borderRadius: 'var(--radius-sm)',
          fontSize: 'var(--fs-sm)',
          fontWeight: 500,
          // Default (warning-like) — MUI overrides per severity below
          backgroundColor: 'var(--surface-2)',
          border: '1px solid var(--border)',
          color: 'var(--ink)',
          '& .MuiAlert-icon': { color: 'var(--muted)' },
          '&.MuiAlert-standardWarning': {
            backgroundColor: severityMap.warning.bg,
            border: `1px solid color-mix(in oklch, ${severityMap.warning.border} 20%, transparent)`,
            color: severityMap.warning.color,
            '& .MuiAlert-icon': { color: severityMap.warning.icon },
          },
          '&.MuiAlert-standardError': {
            backgroundColor: severityMap.error.bg,
            border: `1px solid color-mix(in oklch, ${severityMap.error.border} 20%, transparent)`,
            color: severityMap.error.color,
            '& .MuiAlert-icon': { color: severityMap.error.icon },
          },
          '&.MuiAlert-standardSuccess': {
            backgroundColor: severityMap.success.bg,
            border: `1px solid color-mix(in oklch, ${severityMap.success.border} 20%, transparent)`,
            color: severityMap.success.color,
            '& .MuiAlert-icon': { color: severityMap.success.icon },
          },
          '&.MuiAlert-standardInfo': {
            backgroundColor: severityMap.info.bg,
            border: `1px solid color-mix(in oklch, ${severityMap.info.border} 20%, transparent)`,
            color: severityMap.info.color,
            '& .MuiAlert-icon': { color: severityMap.info.icon },
          },
        };
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: {
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(10,10,15,0.5)',
          backdropFilter: 'blur(8px)',
        },
        '& .MuiDialog-paper': {
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--border)',
          backgroundColor: 'var(--surface)',
          boxShadow: 'var(--shadow-lg)',
          backgroundImage: 'none',
        },
      },
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        height: 6,
        borderRadius: 999,
        backgroundColor: 'var(--surface-2)',
        '& .MuiLinearProgress-bar': {
          backgroundColor: 'var(--accent)',
          borderRadius: 999,
        },
      },
    },
  },
};
